import Vue from 'vue'

// axios
import axios from 'axios'
import store from './store'
import router from './router'
const axiosIns = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // JWT API'sinin taban URL'si
  timeout: 30000, // İstek zaman aşımı süresi
})

Vue.prototype.$http = axiosIns

axiosIns.interceptors.request.use(
  (config) => {
    const isGet = config.method === 'get';
    const isFormData = config.data instanceof FormData;

    // GET için param ekleme
    if (isGet) {
      if (store.getters['user/isFenomen']) {
        config.params = {
          ...config.params,
          infId: store.state.user.userData.id
        };
      } else {
        config.params = {
          ...config.params
        };
      }
    } else {
      // POST, PUT, DELETE vb. için
      if (!isFormData) {
        config.data = {
          ...config.data
        };
      }
    }

    // Content-Type: sadece FormData değilse manuel ayarla
    if (!isFormData) {
      config.headers['Content-Type'] = 'application/json';
    } else {
      // FormData ise Content-Type'ı hiç ayarlama, Axios kendi ayarlıyor (boundary vs.)
      delete config.headers['Content-Type'];
    }

    // Customer-SK ekle
    const isAuthEndpoint = config.url.includes('/auth/login') 
      || config.url.includes('/auth/forgot-password')
      || config.url.includes('/auth/verifyPassword');

    if (
      !isAuthEndpoint &&
      !config.url.includes('manage') &&
      !config.url.includes('developer') &&
      !config.headers['Customer-SK'] &&
      store.state.user.customerInfo
    ) {
      const secretKey = store.state.user.customerInfo?.secret_key || null;
      if (secretKey) {
        config.headers['Customer-SK'] = secretKey;
      }
    }

    // Token ekle
    const token = localStorage.getItem('accessToken');
    if (token && !config.headers.Authorization) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

// axios.js dosyasının başında, modül seviyesinde tanımlayın
let isHandling401Error = false;

// İnterceptor tanımlaması
axiosIns.interceptors.response.use(function (response) {
  return response
}, function(error) {
  console.log("Hata alındı:", error); // Hata durumunun loglanması

  // Sadece bu request için logout/redirect yapma
  if (error.config?.skipAuthRedirect === true) {
    return Promise.reject(error);
  }

  if (!error.response) {
    if (!isHandling401Error) {
      isHandling401Error = true;
      store.commit('user/LOGOUT_USER')
      router.replace({ path: '/login' })
      Vue.$toast.error('Bağlantı hatası. Lütfen yeniden giriş yapın.');
      
      // Bayrak sıfırlama
      setTimeout(() => {
        isHandling401Error = false;
      }, 2000);
    }
    return Promise.reject(error);
  } 
  
  // status'un sayı olarak kontrol edilmesi
  if(error.response.status === 401){ // String yerine sayı olarak karşılaştırma
    if (!isHandling401Error) {
      isHandling401Error = true;
      console.log("401 hatası yakalandı, oturum kapatılıyor...");
      store.commit('user/LOGOUT_USER')
      router.replace({ path: '/login' })
      Vue.$toast.error('Oturum süreniz doldu. Lütfen yeniden giriş yapın.');
      
      // Bayrak sıfırlama
      setTimeout(() => {
        isHandling401Error = false;
      }, 2000);
    }
    return Promise.reject(error);
  } else if(error.response.status === 403){ // String yerine sayı olarak karşılaştırma
    router.replace({ path: '/no-access' })
    return Promise.reject(error);
  }
  
  return Promise.reject(error.response ? error.response.data : error);
})

export default axiosIns
